import React from 'react';
const pains = [{
  emoji: '🎈',
  title: 'Inflamación matutina',
  desc: 'Te levantás y ya te sentís inflamada.'
}, {
  emoji: '🐢',
  title: 'Metabolismo lento',
  desc: 'Comés poco… pero igual aumentás de peso.'
}, {
  emoji: '😔',
  title: 'Cuerpo diferente',
  desc: 'Sentís que tu cuerpo ya no es el mismo.'
}, {
  emoji: '🔋',
  title: 'Cansancio extremo',
  desc: 'Te sentís agotada todo el día, sin energía.'
}, {
  emoji: '🍪',
  title: 'Más ansiedad',
  desc: 'Tenés más ansiedad que antes.'
}, {
  emoji: '📉',
  title: 'Estancamiento',
  desc: 'Te cuesta cada vez más bajar.'
}, {
  emoji: '💔',
  title: 'Culpa constante',
  desc: 'Sentís culpa por no poder lograrlo.'
}];
export function PainPoints() {
  return <section className="py-20 bg-bg-warm" data-id="element-158">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-159">
        <div className="text-center mb-12" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-161">
            Leé esto y decime si te pasa:
          </h2>
          <div className="w-24 h-1 bg-coral mx-auto rounded-full" data-id="element-162"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-163">
          {pains.map((pain, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-soft border border-gray-100 hover:shadow-card transition-shadow duration-300" data-id="element-164">
              <div className="text-4xl mb-4 bg-blush w-16 h-16 rounded-full flex items-center justify-center" data-id="element-165">
                {pain.emoji}
              </div>
              <h3 className="text-xl font-bold text-text-dark mb-2" data-id="element-166">
                {pain.title}
              </h3>
              <p className="text-text-medium leading-relaxed" data-id="element-167">{pain.desc}</p>
            </div>)}
        </div>

        <div className="text-center bg-rose/10 p-6 rounded-2xl border border-rose/20 max-w-3xl mx-auto" data-id="element-168">
          <p className="text-xl md:text-2xl font-semibold text-coral-dark" data-id="element-169">
            👉 Si te identificaste con 2 o más…{' '}
            <br className="hidden md:block" data-id="element-170" />
            <span className="text-text-dark" data-id="element-171">
              esto explica EXACTAMENTE lo que te está pasando.
            </span>
          </p>
        </div>
      </div>
    </section>;
}